import React, { Component } from 'react';
import { appImgAlt, domainUrl, routeAfterLogin } from '../config/Config';
import { getUserData, setUserData, reactLoader, message, getTokenData, parseJwt } from '../helpers/Common';
import { UserId, Username } from '../helpers/User';
import Footer from '../partials/Footer';

// Assign $ value to use jquery
const $ = window.$;

export default class LoginAddObserver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: getUserData("appFullDate", true),
            appImgAlt: appImgAlt,
            countryCodes: [],
            relations: []
        };
    }
    getCountryCodes() {
        reactLoader("show", "Loading...");
        fetch(domainUrl + "getcountrycodes", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status == 2) {
                this.setState({
                    countryCodes: responseJson.country_data
                });
            }
        });
    }
    getRelations(product_id) {
        reactLoader("show", "Loading...");
        fetch(`${domainUrl}products/${product_id}?expand=relationship`, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status == 1 && responseJson.data.relationship.length > 0) {
                this.setState({
                    relations: responseJson.data.relationship
                });
            }
        });
    }
    addObserver() {
        reactLoader("show", "Please wait...");
        let formData = new FormData(),
            formInputs = $('#frmAddObserver').serializeArray();
        formInputs.map((val, index) => {
            formData.append(val.name, val.value);
        });
        fetch(domainUrl + "user/addobservers", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
            },
            body: formData,
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 0) {
                reactLoader("hide");
                message(responseJson.message, responseJson.errors, 'error');
            } else {
                let userData = parseJwt(getTokenData());
                if (userData.afterRoutes.length > 1) {
                    userData.afterRoutes.splice(0, 1);
                    setUserData("afterRoutes", userData.afterRoutes, true);
                    setTimeout(() => {
                        reactLoader("hide");
                        this.props.router.push(userData.afterRoutes[0].url);
                    }, 1200);
                } else {
                    setUserData("globalAccess", true, true);
                    setTimeout(() => {
                        setUserData("afterRoutes", [], true);
                    }, 500);
                    setTimeout(() => {
                        reactLoader("hide");
                        this.props.router.push(routeAfterLogin);
                    }, 1200);
                }
            }
        });
    }
    componentWillMount() {
        this.getRelations(getUserData("productID", true));
        this.getCountryCodes();
    }
    componentDidMount() {
        document.body.className = "inner";
    }
    render() {
        const contryCodeOptions = this.state.countryCodes.map((val, index) => <option key={`contry_code_${index}`} value={val.id}>{val.name_code}</option>);
        const relationOptions = this.state.relations.map((key, index) => <option key={`relation_${index}`} value={key.name}>{key.name}</option>);
        return (<div className="row">
            <header>
                <div className="logo"><img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="" title={this.state.appImgAlt} border="0" /></div>
                <div className="top-links reg-page"><img src={process.env.PUBLIC_URL + '/images/calendar_icon.png'} alt="" title="" border="0" /><span>{this.state.date}</span></div>
            </header>
            <section className="maincontent">
                <section className="content">
                    <div className="obslogin">
                        <h1>Welcome {Username()},</h1>
                    </div>
                    <p>OBSERVERS will be interacting with you right through the program. You choose your own observers, who could be your friends, family, seniors or teachers - anybody who can play a productive role in your learning and development. Many of the works you submit during the program will be reaching your observers for their feedback and rating.<br /><br />You need <b>at least one observer</b> and a maximum of any number. They will receive a mail through which they can accept your request. Please note that without observers, you would not be able to start the program.</p>
                    <div id="showobs">
                        <section className="viewport">
                            <section className="overview">
                                <br /><br />Please fill in your details below as part of the mandatory process:
								<form action="#" method="post" id="frmAddObserver">
                                    <div className="gray-box">
                                        <div className="frm">
                                            <div className="frm-left">
                                                <div className="frm-left-txt">Observer Name <span className="txt-red">*</span></div>
                                                <div className="frm-right-txt">
                                                    <input type="hidden" name="learner_id" value={UserId()} />
                                                    <input type="hidden" name="current_index[]" value="0" />
                                                    <input type="text" name="name[]" className="txtbox" />
                                                </div>
                                            </div>
                                            <div className="frm-right">
                                                <div className="frm-left-txt">Email Id <span className="txt-red">*</span></div>
                                                <div className="frm-right-txt">
                                                    <input name="email[]" type="text" className="txtbox" />
                                                </div>
                                            </div>
                                            <div className="clear"></div>
                                            <div className="frm-left">
                                                <div className="frm-left-txt">Relationship <span className="txt-red">*</span></div>
                                                <div className="frm-right-txt">
                                                    <select name="relation[]">
                                                        <option value="">--- Select ---</option>
                                                        {relationOptions}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="frm-right">
                                                <div className="frm-left-txt">Gender <span className="txt-red">*</span></div>
                                                <div className="frm-right-txt">
                                                    <div className="radio-box">
                                                        <input name="gender_0" className="rdbtn" type="radio" value="1" defaultChecked />&nbsp;Male
						                                            &nbsp; <input name="gender_0" className="rdbtn" type="radio" value="0" />&nbsp;Female
						                                        </div>
                                                </div>
                                            </div>
                                            <div className="clear"></div>
                                            <div className="frm-left">
                                                <div className="frm-left-txt">Contact Number <span className="txt-red">*</span></div>
                                                <div className="frm-right-txt">
                                                    <select name="ISD[]">
                                                        <option value="">--- Select ---</option>
                                                        {contryCodeOptions}
                                                    </select>
                                                    <input type="text" className="textbox-mini" name="STD[]" maxLength="6" style={{ width: "70px" }} /> - <input type="text" className="txtbox-medium" name="phone[]" maxLength="10" />
                                                    <br /><span className="txt-small">STD code &nbsp;&nbsp;&nbsp;&nbsp; - &nbsp; Phone</span>
                                                </div>
                                            </div>
                                            <div className="frm-right">&nbsp;</div>
                                            <div className="clear"></div>
                                            <div style={{ textAlign: "right" }}>
                                                <input type="button" value="Add Observer" onClick={() => this.addObserver()} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </section>
                        </section>
                    </div>
                </section>
            </section>
            <Footer />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/LoginAddObserver.js